import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  ModelBase
} from "@models";
import { 
  Table, 
  TableBase, 
} from "@dndModels";
import { CHARACTER_LEVELS, FEATURE_SOURCE_TYPE_OPTIONS } from "@dndModels/Constants";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import TableInput from "@dndComponents/other/TableInput";
import { DataType } from '@dndModels/Types';

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function TableEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Table>(param_obj instanceof Table ? param_obj : api.applyWorkingOn(new Table()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  let level_options = [...CHARACTER_LEVELS];
  level_options = level_options.filter(o => obj.entries.filter(o2 => `${o2.level}` === o).length === 0);
  if (obj.entries.filter(o => o.level === 20).length === 0) {
    level_options.push("Next");
  }
  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof Table) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            name="Type"
            value={obj.type} 
            options={FEATURE_SOURCE_TYPE_OPTIONS}
            disabled={disabled}
            onChange={(changed: DataType) => {
              const new_obj = obj;
              new_obj.type = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          { obj.type !== "" &&
            <SelectObjectBox 
              name="For"
              value={obj.for_id} 
              data_type={obj.type}
              disabled={disabled}
              dominant_only
              show_details
              auto_sort
              // log_it
              onChange={(changed: string) => {
                const new_obj = obj;
                new_obj.for_id = changed;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <TableInput
            obj={obj}
            disabled={disabled}
            onChange={(changed: TableBase) => {
              const new_obj = obj;
              new_obj.copyBase(changed);
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
      </Grid>
    </ModelBaseInput>
  );
}
